<!--

TODO - emitted event should have info about file size, type, if it can be used with whatsapp or any other service we will integrate, if the file supports caption or not and etc.
       It should also emit the error message saying the file is too big or file type unsupported.

-->

<template>
  <div class="drop-zone">
    <div
      class="drop-wrapper"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop">
      <form
        ref="dragForm"
        @submit.prevent="onSubmit">
        <input
          :id="inputId"
          ref="file"
          :name="inputId"
          type="file"
          multiple
          @change="onChange">
      </form>

      <div
        class="drop-top"
        :class="{ selected: fileList.length }">
        <label
          v-if="!tempFileName && !dropActive && !fileList.length"
          :for="inputId">{{ placeholder }}</label>
        <div
          v-if="tempFileName || (!dropActive && fileList.length)"
          class="drop-file-list">
          <span class="strong">{{ fileList && fileList.length ? fileList[0].name : tempFileName }}</span> <span v-if="fileList && fileList.length">({{ fileList[0].size | prettyBytes }})</span>
          <span
            class="clear-btn"
            @click="clearFile()"/>
        </div>
      </div>

      <p v-if="dropActive" class="content">
        Drop file
      </p>

    </div>
    <p
      v-if="unsupportedFileType"
      class="error flex flex-align-center">
      <SBIcon
        :icon="SBIconList.ERROR"
        :color="SBColors.redPrimary"
        :size="12" />
      <span>{{ supportedFileTypeMessage }}</span>
      <!-- <b-icon
        id="tooltip-file-validator"
        icon="question-circle"
        class="info-label"/>
      <b-popover
        target="tooltip-file-validator"
        triggers="hover"
        placement="auto">
        <h1>Supported file types</h1>
        <p>{{allowedFileTypesList}}</p>
      </b-popover> -->
    </p>
    <p
      v-if="fileTooBig"
      class="error flex flex-align-center">
      <SBIcon
        :icon="SBIconList.ERROR"
        :color="SBColors.redPrimary"
        :size="12" />
      <span>{{ maxSizeError }}</span>
    </p>
  </div>
</template>

<style lang="scss" scoped>
.drop-wrapper {
  width: 100%;
  height: 32px;
  position: relative;
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
  border: solid 1px #cfd8dc;
  background-color: #ffffff;
  overflow: hidden;
}

input {
  display: none;
}

.drop-top {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding-left: 30px;

  &::before {
    content: '';
    width: 14px;
    height: 14px;
    position: absolute;
    top: 7px;
    left: 10px;
    mask-image: url(~@/assets/img/SB-Icons/attach.svg);
    mask-size: 14px 14px;
    mask-repeat: no-repeat;
    mask-position: center;
    background-color: $cadetBlue;
  }

  &.selected::before {
    background-color: $blackPrimary;
  }

  label {
    display: block !important;
    width: 100% !important;
    padding: 8px 8px 8px 0px !important;
    line-height: 1.21 !important;
    color: $cadetBlue !important;
    cursor: pointer !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    text-transform: unset !important;
    font-size: 14px !important;
    font-weight: 400 !important;
  }

  .drop-file-list {
    white-space: nowrap;
    width: calc(100% - 30px);
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px !important;

    .strong {
        font-weight: 500 !important;
    }

    .b-icon {
      position: absolute;
      right: 0px;
      top: 0px;
      background: white;
      padding: 8px;
      width: 30px;
      height: 30px;
    }

    .clear-btn {
      mask-size: 8px 8px !important;
    }

  }
}

.error {
  margin-top: 5px;
  padding: 5px 6px;
  color: #ff5b61;
  font-size: 16px;
  display: flex;
  align-items: center;

  .info-label {
      margin-left: 5px;
  }

  .sb-icon {
    margin-right: 6px;
  }
}

.content {
  width: 100%;
  padding: 8px 8px 8px 8px;
  text-align: center;
  line-height: 1.21;
  color: #9eafb5;
  margin-bottom: 0;
}

.show-overlay .content {
  background: #f8fafb;
  color: $textGray;
}
</style>

<script>
/**
 * TODO this needs to be fully refactored to accept multiple files and show them as list
 */
import { getFileExtension } from '@/helpers/mediaHelpers';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import randomString from '@/helpers/randomString';

export default {
  name: 'DropZone',
  components: {
    SBIcon,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    extensions: {
      type: Array,
      default: null,
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Select or drop file here',
    },
    unsupportedFileTypeMessage: {
      type: String,
      required: false,
      default: null,
    },
    /** Value in bytes */
    maxFileSize: {
      type: Number,
      required: false,
      default: null,
    },
    fileTooBigMessage: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * In case we need to edit the form and we have a file name we can pass it here and show the file as selected.
     * On clear the component will emit the 'clear' event and the parent should clear the tempFileName.
     */
    tempFileName: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      fileList: [],
      fileTooBig: false,
      dropActive: false,
      unsupportedFileType: false,
      inputId: '',
      SBIconList,
      SBColors,
    };
  },
  computed: {
    allowedFileTypesList() {
      return this.extensions.join(', ');
    },
    supportedFileTypeMessage() {
      return this.unsupportedFileTypeMessage ? this.unsupportedFileTypeMessage : `Supported file type is ${this.$options.filters.uppercase(this.allowedFileTypesList)}`;
    },
    maxSizeError() {
      return this.fileTooBigMessage ? this.fileTooBigMessage : `File is too big. Max size ${this.$options.filters.prettyBytes(this.maxFileSize, 1)}`;
    },
  },
  beforeMount() {
    this.inputId = `fileField-${randomString()}`;
  },
  methods: {
    onChange() {
      if (!this.acceptableFileType(this.$refs.file.files)) {
        return;
      }
      this.fileList = [...this.$refs.file.files];
      if (this.maxFileSize && this.fileList[0].size > this.maxFileSize) {
        this.fileTooBig = true;
        this.$emit('error', true);
        return;
      }
      this.fileTooBig = false;
      this.$emit('error', false);
      // Do not emit on cancel
      if (this.fileList.length) {
      // only work with one file for now
        this.$emit('input', [...this.fileList].slice(0, 1));
        this.$emit('dropped-in', [...this.fileList]);
      }
    },
    remove(i) {
      this.fileList.splice(i, 1);
    },
    clearFiles() {
      this.fileList = [];
      this.$refs.dragForm.reset();
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains('show-overlay')) {
        event.currentTarget.classList.add('show-overlay');
        this.dropActive = true;
      }
    },
    dragleave(event) {
      event.preventDefault();
      event.currentTarget.classList.remove('show-overlay');
      this.dropActive = false;
    },
    /**
     * Checks if the file is on the list of acceptable extensions.
     * If no extension is set the all files are acceptable.
     */
    acceptableFileType(files) {
      const fileToCheck = files[0];
      const isFileAcceptable = this.extensions
        ? this.extensions.includes(getFileExtension(fileToCheck.name))
        : true;
      if (isFileAcceptable) {
        this.unsupportedFileType = false;
        this.$emit('error', false);
      } else {
        this.unsupportedFileType = true;
        this.$emit('error', true);
      }
      return isFileAcceptable;
    },
    drop(event) {
      event.preventDefault();
      if (!this.acceptableFileType(event.dataTransfer.files)) {
        event.currentTarget.classList.remove('show-overlay');
        this.dropActive = false;
        return;
      }
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange();
      event.currentTarget.classList.remove('show-overlay');

      this.dropActive = false;
    },
    clearFile() {
      this.fileTooBig = false;
      this.$emit('error', false);
      this.fileList = [];
      this.$emit('input', []);
      this.$emit('dropped-in', []);
      this.$refs.file.value = '';
      this.$emit('clear');
    },
  },
};
</script>
